import React from 'react';

import css from './external-link.module.scss';

interface ExternalLinkProps extends React.HTMLAttributes<HTMLAnchorElement> {
    href: string;
    text?: string;
    icon?: string;
    className?: string;
}

export const ExternalLink: React.FC<ExternalLinkProps> = ({
    href,
    text,
    icon,
    className,
}) => {
    return (
        <a
            href={href}
            className={`${className} ${css.root}`}
            target="_blank"
            rel="noopener noreferrer"
        >
            {icon ? (
                <img className={css.linkIcon} alt={text} src={icon} />
            ) : (
                <>{text}</>
            )}
        </a>
    );
};
